import { createSelector } from 'reselect';
import { RootState } from 'store';
import adapter from './committedOrders.adapter';
import { OrderParams } from '../orders.types';
import { REDUCER_KEY } from './committedOrders.consts';

const selectors = adapter.getSelectors(
  (state: RootState) => state[REDUCER_KEY],
);
export const { selectIds, selectTotal, selectAll } = selectors;

export const selectById = (state: RootState, id: number): OrderParams | null =>
  selectors.selectById(state, id) || null;

export const selectAllCommittedOrders = createSelector(
  state => selectors.selectAll(state),
  committedOrders => committedOrders || [],
);

export function selectCommittedOrder(
  state: RootState,
  orderId: number,
): OrderParams | undefined {
  return selectors.selectById(state, orderId) || undefined;
}

export function selectCommittedOrdersOfBasket(
  state: RootState,
  basketId: number,
): OrderParams[] {
  return selectors
    .selectAll(state)
    .filter(order => order.basketId === basketId);
}
